import { Component, OnInit } from '@angular/core';
import { DocService } from "../services/doc.service";
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
	selector: 'release-component',
	templateUrl: './release.component.html',
	styleUrls: ['./release.component.scss'],
	providers: [DocService]
})

export class ReleaseComponent {
    public release: string;

	constructor(private _http: HttpClient, private _activatedRoute: ActivatedRoute) { 
        this._http.get('assets/RELEASENOTES.md', { responseType: 'text' }).subscribe(data => {
            this.release = data;
        }); 
    }

	async ngOnInit() {
	}	
}
